import { createContext } from 'react';

const pageContext = createContext();

export default pageContext;